import { render } from "./MultiConnect.vue?vue&type=template&id=81dbd88c&ts=true"
import script from "./MultiConnect.vue?vue&type=script&lang=ts"
export * from "./MultiConnect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/connect-widgets/connect-widgets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__